import { PERMISSIONS } from '../usersPermissions/usersPermissionsCadernoLPMA';

const SYS_ADMIN = 'system.admin';

export const isAdmin = (roles: string[]): boolean => {
    return (roles ?? []).some(role => role === PERMISSIONS.Admin || role === SYS_ADMIN);
}
